import Vue from 'vue'
import Element from 'element-ui'
import '../element-variables.scss'
import 'element-ui/packages/theme-chalk/src/index.scss'
import locale from 'element-ui/lib/locale/lang/en'

import ElCollapseTransition from '../components/element/ElCollapseTransition.vue'

Vue.use(Element, { locale })
Vue.component('ElCollapseTransition', ElCollapseTransition)
